import { render, staticRenderFns } from "./alert-notification-traffic.vue?vue&type=template&id=b9701428&scoped=true&"
import script from "./alert-notification-traffic.vue?vue&type=script&lang=ts&"
export * from "./alert-notification-traffic.vue?vue&type=script&lang=ts&"
import style0 from "./alert-notification-traffic.vue?vue&type=style&index=0&id=b9701428&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9701428",
  null
  
)

export default component.exports